import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppAuthService } from './app-auth.service';
import { CurrentMemberProvider } from './current-member-provider.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private currentMemberProvider: CurrentMemberProvider,
  ) {
  }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isAuthenticated = this.currentMemberProvider.isAuthenticated();

    if (!isAuthenticated) {
      window.localStorage.setItem('entryRequest', state.url);
      this.router.navigateByUrl(AppAuthService.loginPage);
    }

    return isAuthenticated;
  }
}
